import React, { Component } from 'react';
import TooieModal from "../common/TooieModal.react.js";

let i18n = require("i18next");

export default class PaymentNotesModal extends Component {
    render() {
        let notes = this.props.paymentNotes.length>0 ? this.props.paymentNotes.map((note, i) => {
            return (<div className="note-item" key={i}>
                <span>{note}</span>
            </div>);
        }) : null;

        return (
            <TooieModal id="paymentNotesModal" title={i18n.t("pos.cashier.add.note")}>
                <div className="payment-notes">
                    <div className="note-list">
                        {notes}
                    </div>

                    <div className="other-note">
                        <textarea rows="4" className="note medium" placeholder={i18n.t("pos.cashier.addnote.placeholder")}></textarea>
                    </div>
                    <div className="bottom-bar">
                        <button className="btn saveNote">{i18n.t("pos.save")}</button>
                    </div>
                </div>
            </TooieModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/modal/PaymentNotesModal.react.js